export default __webpack_public_path__ + "static/media/map.97e48e02.jpg";